import AssessmentsSvg from 'assets/menu-list-icon/assessments.svg';
import biographySvg from 'assets/menu-list-icon/biography.svg';
import carePlanningSvg from 'assets/menu-list-icon/carePlanning.svg';
import {
  default as careReportSvg,
  default as hospitalReportSVG,
} from 'assets/menu-list-icon/careReport.svg';
import consultationSvg from 'assets/menu-list-icon/consultation.svg';
import executionSvg from 'assets/menu-list-icon/execution.svg';
import HealthSvg from 'assets/menu-list-icon/health.svg';
import logsSvg from 'assets/menu-list-icon/logs.svg';
import routePaths from 'constants/route-paths';

export default [
  {
    name: 'health',
    svgIcon: HealthSvg,
    pathname: routePaths.HEALTH,
    submenu: [
      {
        name: 'medication',
        pathname: routePaths.HEALTH_MEDICATION,
      },
      {
        name: 'visit_sheet',
        pathname: routePaths.HEALTH_VISIT_SHEET,
      },
      {
        name: 'doctors_diagnoses',
        pathname: routePaths.HEALTH_DOCTORS_DIAGNOSES,
      },
      {
        name: 'vital_information',
        pathname: routePaths.HEALTH_VITAL_INFORMATION,
      },
    ],
  },
  {
    name: 'assessments',
    svgIcon: AssessmentsSvg,
    pathname: routePaths.ASSESSMENTS,
    submenu: [
      {
        name: 'movement_status',
        pathname: routePaths.MOVEMENT_STATUS,
      },
      {
        name: 'pressure_ulcer_risk',
        pathname: routePaths.DECUBITUS_RISK,
      },
      {
        name: 'risk_of_falling',
        pathname: routePaths.RISK_OF_FALLING,
      },
    ],
  },
  {
    name: 'care_planning',
    pathname: routePaths.CARE_PLAN,
    svgIcon: carePlanningSvg,
  },
  {
    name: 'execution',
    svgIcon: executionSvg,
    pathname: routePaths.EXECUTION,
    submenu: [
      // Future feature (Execution Proof Overvies form)
      // {
      //   name: 'maintenance',
      //   pathname: routePaths.EX_MAINTENNANCE,
      // },
      {
        name: 'monthly_overview',
        pathname: routePaths.EX_MONTHLY_OVERVIEW,
      },
      {
        name: 'social_care',
        pathname: routePaths.EX_SOCIAL_CARE,
      },
    ],
  },
  {
    name: 'care_report',
    pathname: routePaths.NURSING,
    svgIcon: careReportSvg,
  },
  {
    name: 'logs',
    svgIcon: logsSvg,
    pathname: routePaths.LOGS,
    submenu: [
      {
        name: 'wound_documentation',
        pathname: routePaths.WOUND_DOCUMENTATION,
      },
      {
        name: 'pain_assessment',
        pathname: routePaths.PAIN_ASSESSMENT,
      },
      {
        name: 'nutrition_drinking_log',
        pathname: routePaths.NUTRITION_DRINKING_LOG,
      },
      {
        name: 'vital_signs_protocol',
        pathname: routePaths.FALL_PROTOCOL,
      },
      {
        name: 'vital_sign',
        pathname: routePaths.VITAL_SIGN,
      },
    ],
  },
  {
    name: 'consultation',
    pathname: routePaths.CONSULTATION,
    svgIcon: consultationSvg,
  },
  // Future feature (Evaluation Pages)
  // {
  //   name: 'evaluation',
  //   svgIcon: evaluationSvg,
  //   submenu: [
  //     {
  //       name: 'care_rounds',
  //       pathname: routePaths.EXAL_CARE_ROUNDS,
  //     },
  //     {
  //       name: 'appraisal',
  //       pathname: routePaths.EXAL_APPRAISAL,
  //     },
  //     {
  //       name: 'indicators',
  //       pathname: routePaths.EXAL_INDICATORS,
  //     },
  //     {
  //       name: 'case_discussion',
  //       pathname: routePaths.EXAL_CARE_DISCUSSION,
  //     },
  //   ],
  // },
  {
    name: 'biography',
    pathname: routePaths.BIOGRAPHY,
    svgIcon: biographySvg,
  },
  {
    name: 'nurse_visit',
    pathname: routePaths.NURSE_VISIT,
    svgIcon: careReportSvg,
  },
  {
    name: 'hospital_export',
    pathname: routePaths.REPORT,
    svgIcon: hospitalReportSVG,
  },
  {
    name: 'pflegegrad_assessment',
    pathname: routePaths.PFLEGEGRAD_ASSESSMENT,
    svgIcon: hospitalReportSVG,
  },
];
